$(document).ready(function() {
  return $('#expenseModal').on('show.bs.modal', function(event) {
    var link, modal;
    link = $(event.relatedTarget);
    modal = $(this);
    return modal.find('.modal-content').load(link.data("path"));
  });
});
